import { Component, Fragment } from "react";
import { withRouter } from '../utils/withRouter.js';
import { useNavigate } from "react-router-dom";
import userJourney from '../utils/userJourneyLogger'; // Add this import

import './Logout.css';

function Logout(props) {
    let navigate = useNavigate();

    async function handleLogout(event) {
        event.preventDefault();

        // Log the explicit logout BEFORE clearing localStorage
        userJourney.logExplicitLogout();

        // There should only be one key/value pair in localStorage 
        // so we can be lazy and just call clear()
        localStorage.clear();

        navigate("/");
    }

    if (!props.isLoggedIn) {
        return null;
    }

    return (
        <Fragment>
            <a href="#" onClick={handleLogout}>
                <img src="/assets/imgs/logout_icon.svg" alt="logout" className="img-button"/>
            </a>
        </Fragment>
    )
}

export default withRouter(Logout);